(function () {
  const modal = document.querySelector('[data-sleep-quiz-teaser]');
  if (!modal) return;

  const openers = document.querySelectorAll('[data-sleep-quiz-open]');
  const closers = modal.querySelectorAll('[data-sleep-quiz-close]');
  const panel = modal.querySelector('.sq-teaser__panel');
  const primary = modal.querySelector('[data-sleep-quiz-start]');
  const defaultUrl = (primary && primary.getAttribute('href')) || '/pages/sleep-quiz?start=1';
  let lastFocus = null;

  function trackQuizEvent(name, params) {
    const payload = Object.assign(
      {
        quiz_name: 'sleep_quiz',
        page_path: window.location.pathname,
      },
      params || {}
    );

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
      return;
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name }, payload));
    }
  }

  function buildStartUrl(base) {
    if (!base) return defaultUrl;
    if (base.indexOf('start=1') !== -1) return base;
    return base.indexOf('?') === -1 ? base + '?start=1' : base + '&start=1';
  }

  function openModal(event) {
    if (event) event.preventDefault();
    lastFocus = document.activeElement;

    const opener = event && event.currentTarget;
    const customUrl = opener && opener.getAttribute('data-sleep-quiz-url');
    const entryPoint = opener && opener.closest('.who-quiz-cta') ? 'who_is_it_for' : 'buy_box';
    if (primary) {
      primary.setAttribute('href', buildStartUrl(customUrl || defaultUrl));
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sq-teaser-open');
    trackQuizEvent('quiz_modal_open', { entry_point: entryPoint });
    const closeBtn = modal.querySelector('[data-sleep-quiz-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sq-teaser-open');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  openers.forEach(function (el) {
    el.addEventListener('click', openModal);
  });

  closers.forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', function (event) {
    if (event.target === modal || event.target.hasAttribute('data-sleep-quiz-close-backdrop')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  if (panel) {
    panel.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }
})();
